import { useTranslate } from "@refinedev/core";
import { useEffect } from "react";

type Title = string | { i18nKey: string };

const suffix = " | VIA AIOps";

export const usePageTitle = (title?: Title) => {
  const translate = useTranslate();

  useEffect(() => {
    if (!title) return;

    if (typeof title === "string") {
      document.title = translate(title) + suffix;
    } else {
      document.title = translate(title.i18nKey) + suffix;
    }
  }, [title]);

  return (title: Title) => {
    if (typeof title === "string") {
      document.title = translate(title) + suffix;
    } else {
      document.title = translate(title.i18nKey) + suffix;
    }
  };
};
